import React, { useEffect, useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import axiosInstance from '../utils/axios';

const UserPicker = ({ orgIdFilter = "&", pickerTitle = "Please Select A User", onSelect=onSelect, inputUserId=null }) => {
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [userList, setUserList] = useState([]);

    // Fetch users based on the filter
    const fetchFilteredUserList = async (organizationFilter) => {
        try {
            let query = '/users/';
            const queryParams = [];

            if (organizationFilter) {
                queryParams.push(`profile__organization__id=${organizationFilter}`);
            }

            if (queryParams.length > 0) {
                query += `?${queryParams.join('&')}`;
            }

            const response = await axiosInstance.get(query);
            setUserList(response.data);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    useEffect(() => {
        console.dir("UserPicker useEffect")
        console.dir(inputUserId)
        console.dir(orgIdFilter)
        fetchFilteredUserList(orgIdFilter);
        if (inputUserId) {
            setSelectedUserId(inputUserId)
        }
    }, [orgIdFilter, inputUserId]);

    const handleUserChange = (e) => {
        const newUserId = e.target.value;
        const user = userList.find((user) => user.id === newUserId);

        setSelectedUserId(user.id);  // Update the selected user

        if (onSelect != null) {
            onSelect(user.id, user);
        }
    };

    return (
        <FormControl variant="outlined" fullWidth>
            <InputLabel id="user-picker-label">{pickerTitle}</InputLabel>
            <Select
                labelId="user-picker-label"
                value={selectedUserId}
                onChange={handleUserChange}
                label={pickerTitle}
            >
                <MenuItem value="" disabled>
                    {pickerTitle}
                </MenuItem>
                {userList.map((user) => (
                    <MenuItem key={user.id} value={user.id}>
                        {user.email}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default UserPicker;
